//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../../services/reports";
import moment from "moment";
import pointsservice from "../../../../services/points";
import { seriesColor, unitsservice, pointName, DateTime, array, number } from "../../../../utils";
import { actions as seriesColorActions } from "../../../../services/SeriesColor/redux";

const initialState = {};

/////////
//types
export const types = {
	LOAD_DATA: "components/barchart/LOAD_DATA"
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.LOAD_DATA: {
				return state;
			}
			default:
				return state;
		}
	}
};
function configYAxis(units) {
	let newYAxis = {
		title: {
			text: units,
			align: "high",
			rotation: 0,
			margin: 0,
			y: -30,
			offset: 14,
			style: {
				"font-weight": "600",
				"font-size": "15px"
			}
		},
		labels: {
			style: {
				fontSize: "14px",
				color: "#999"
			}
		}
	};

	if (units == "inSession" ) {
		newYAxis.min = 0;
		newYAxis.max = 1;
		newYAxis.height = "20%";
		newYAxis.top = "80%";
	}

	return newYAxis;
}
//returns teh index of the y index with teh specified units.
//if it doesn't exist it creates a new axis with teh units and returns the index for that axis.
function getAxisIndex(chart, units) {
	if (!chart.options) {
		return;
	}
	let axisIndex = 0;
	let symbol = unitsservice.stringToSymbol(units);
	units = symbol ? symbol : units;
	//if the first yaxis doesnt have a value set then
	if (!chart.yAxis[0].userOptions.title) {
		chart.yAxis[0].update(configYAxis(units));
	} else {
		//search for existing with same units and use that, else add a new axis.
		let axisFound = false;
		for (var ii = 0; ii < chart.yAxis.length; ii++) {
			let wkAxis = chart.yAxis[ii];
			if (wkAxis.userOptions.title.text == units) {
				axisFound = true;
				axisIndex = ii;
				break;
			}
		}
		if (!axisFound) {
			axisIndex = chart.yAxis.length;
			chart.addAxis(configYAxis(units));
		}
	}
	return axisIndex;
}


function applySettings(settings, pointData, fromDate) {
	for (const prop in pointData) {
		if (pointData.hasOwnProperty(prop)) {
			let data = pointData[prop];
			let iteration = 1;
			let timeWindowMins = 1;
			switch (settings) {
				case "Value":
					//already in value form, return
					return;
				case "Group Half-Hourly":
					timeWindowMins = 30;
					break;
				case "Group Hourly":
					timeWindowMins = 60;
					break;
				case "Group Daily":
					timeWindowMins = 1440;
					break;
				default:
					console.warn("Chart setting not recognised: " + settings);
					return;
			}
			pointData[prop] = data.reduce((prev, next) => {
				const comparer = moment(fromDate).add(iteration * timeWindowMins, "minutes");

				if (!prev.length || moment(next.timestamp, "YYYY-MM-DD HH:mm:ss").valueOf() > comparer.valueOf()) {
					//new grouping
					next.timestamp = comparer.format("YYYY-MM-DD HH:mm:ss");
					if (prev.length) {
						iteration++;
					}
					prev.push(next);
				} else {
					//accumulate on existing group
					const last = prev.last();
					last.value += next.value;
				}

				return prev;
			}, []);
		}
	}
}

function* addOutcomes(chart, pointDetails, pointData) {
	if (!chart.options) {
		return;
	}

	const colors = seriesColor.getSeriesColors();
	const timeGranularity = 1000 * 60 * 5; //5mins

	let {colorDictionary, colorIndex} = yield select(x => x.seriesColor);

	for (let index = 0; index < pointDetails.length; index++) {
		const point = pointDetails[index];
		let color = colorDictionary[point.name] ? colorDictionary[point.name] : null;
		if(!color) {
			var newColor = seriesColor.getColorForPoint(point.name);
			if(newColor) {
				color = newColor;
			} else {
				color = colors[colorIndex];
				colorDictionary[point.name] = color;
				colorIndex++;
				if(colorIndex >= colors.length) {
					colorIndex = 0;
				}
				yield put(seriesColorActions.newPoint(point.name, color));
			}
		}

		let runTimeSeries = {
			type: "bar",
			data: pointData[point.objectID].map(xx => {
				return [
					Math.round(DateTime.getGMTDate(xx.timestamp).getTime() / timeGranularity) * timeGranularity,
					xx.value
				];
			}),
			yAxis: getAxisIndex(chart, point.units),
			name: pointName.formatDescription(point),
			color: color,
			pointPadding: 0,
			groupPadding: 0,
			label: point.name,
			borderWidth: 0,
			tooltip: {
				pointFormatter: function() {
					return (
						'<span style="color:{point.color}">\u25CF</span> ' +
						this.series.name +
						": <b>" +
						number.parseNumber(this.y )+
						" " + point.units +
						"</b><br/>"
					);
				}
			}
		};
		chart.addSeries(runTimeSeries);
	}
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.loadData()]);
	},

	*loadData() {
		yield takeEvery(types.LOAD_DATA, function*({ payload }) {
			const component = payload.component;
			const chart = payload.chart;
			const ruleInstanceId = component.ruleInstanceId;
			const fromDate = moment(payload.timePeriod.startDate);
			const toDate = moment(payload.timePeriod.endDate);

			const inputsGrouped = array.groupBy(component.inputs, x => x.source);

			//add ienergy points
			if (inputsGrouped.IEnergy && inputsGrouped.IEnergy.length) {
				let pointIds = [];

				for (let index = 0; index < inputsGrouped.IEnergy.length; index++) {
					const input = inputsGrouped.IEnergy[index];
					for (let ss = 0; ss < input.values.length; ss++) {
						const value = input.values[ss];
						pointIds.push(value.value);
					}
				}

				const pointDetails = yield all(
					pointIds.map(pointId => call(pointsservice.TrendableObjectGetObject, pointId))
				);
				if (pointDetails instanceof Error || !pointDetails) {
					return;
				}
				let pointData = yield call(
					pointsservice.TrendableDataGetData,
					pointDetails.map(x => x.objectID).join(","),
					fromDate,
					toDate
				);
				if (pointData instanceof Error || !pointData) {
					return;
				}
				if (Array.isArray(pointData)) {
					pointData = { [pointIds[0]]: pointData };
				}

				if (component.chartSettings) {
					applySettings(component.chartSettings, pointData, fromDate);
				}

				if (pointDetails && pointData) {
					yield call(addOutcomes, chart, pointDetails, pointData);
				}
			}

			if (inputsGrouped.RuleInstance && inputsGrouped.RuleInstance.length) {
				for (let index = 0; index < inputsGrouped.RuleInstance.length; index++) {
					const wkInput = inputsGrouped.RuleInstance[index];
					for (let vi = 0; vi < wkInput.values.length; vi++) {
						const wkVal = wkInput.values[vi];

						const [ruleDetails, ruleData] = yield all([
							call(pointsservice.GetRuleInstance, wkVal.value),
							call(
								pointsservice.GetRuleInstanceData,
								wkVal.value,
								wkInput.subValues[0].values[index].value,
								fromDate,
								toDate
							)
						]);

						if (ruleDetails instanceof Error || !ruleDetails) {
							return;
						}
						if (ruleData instanceof Error || !ruleData) {
							return;
						}
						ruleDetails.objectID = "Rule";
						yield call(addOutcomes, chart, [ruleDetails], {Rule: ruleData});
					}
				}
			}
			if(payload.onLoadComplete){
				payload.onLoadComplete();
			}
		});
	}
};

////////
//actions
export const actions = {
	loadData(component, chart, timePeriod, onLoadComplete) {
		return {
			type: types.LOAD_DATA,
			payload: { component, chart, timePeriod, onLoadComplete }
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/BarChart/redux.js